import { render } from "./index.vue?vue&type=template&id=52ab8441&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=52ab8441&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ab8441"],['__file',"src/vab/layouts/VabLayoutHorizontal/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52ab8441"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52ab8441', __exports__)) {
    api.reload('52ab8441', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=52ab8441&scoped=true", () => {
    api.rerender('52ab8441', render)
  })

}


export default __exports__